var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHangup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9492 6.50551L19.7513 7.74973C19.5663 8.91477 18.6594 9.69706 17.6315 9.57828L15.5848 9.34071C14.693 9.23752 13.9331 8.47683 13.7071 7.46177L13.0752 4.63617C12.1413 4.17624 11.1115 3.96626 9.98562 4.00626C8.90235 4.03415 7.83476 4.32261 6.84606 4.85454L6.45512 7.50017C6.30714 8.50323 5.61724 9.25072 4.74436 9.35631L2.70965 9.60107C1.69479 9.72345 0.721924 8.94836 0.432965 7.78933L0.124008 6.5451C-0.183948 5.30688 0.0910129 4.00386 0.844907 3.12438C2.62532 1.04867 5.59424 0.00722158 9.75166 2.25948e-05C13.9144 -0.00557662 16.9756 1.02948 18.9354 3.10519C19.7592 3.97866 20.1452 5.27208 19.9502 6.50551",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangup);
export default __webpack_public_path__ + "static/media/hangup.0c0a4ff76a6624cbe4fffa3b7c3c139e.svg";
export { ForwardRef as ReactComponent };